import _ from 'lodash';
import vault from './configuration/vault';

export type Configuration = {
  readonly delimiter: string
  readonly settings: object
  readonly scope: readonly string[]
};

export default function configuration(): Configuration {
  if (typeof process === 'undefined') {
    return {
      delimiter: '.',
      settings: {},
      scope: [] as readonly string[],
    };
  }
  const settings = vault();
  const envSettings = _.toPairs(process.env).reduce(
    (prevSettings: object, pair: readonly [string, any]): object => _.set(prevSettings, pair[0].split('_'), pair[1]),
    _.assign({}, process.env),
  );

  return {
    delimiter: '.',
    settings: _.merge(settings, envSettings),
    scope: [] as readonly string[],
  };
}
